export interface ICountry {
    id: string;
    name: string;
    isoCurrencySymbol: string;
    currencyName: string;
    currencySymbol: string;
  }